import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, CreditCard, AlertTriangle } from 'lucide-react';

export function SubscriptionWall({ userEmail }) {
  const navigate = useNavigate();
  const [daysLeft, setDaysLeft] = useState(0);

  const handleLogout = () => {
    // Clear token
    localStorage.removeItem('token');
    // Navigate to landing
    navigate('/');
    // Reload to clear state
    window.location.reload();
  };

  return (
    <div className="fixed inset-0 bg-[#02040A] z-50 flex items-center justify-center p-6" data-testid="subscription-wall">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-lg w-full bg-gradient-to-b from-white/10 to-transparent backdrop-blur-xl border border-white/20 rounded-3xl p-8 shadow-2xl text-center"
      >
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-500/20 flex items-center justify-center">
          <Lock className="w-10 h-10 text-red-500" />
        </div>

        <h2 className="text-3xl font-bold text-white mb-4">Suscripción Requerida</h2>
        
        <p className="text-white/70 mb-6">
          Tu período de prueba ha expirado. Para continuar usando MÉTODO 11, necesitas suscribirte.
        </p>

        <div className="bg-white/5 rounded-xl p-6 mb-6 border border-white/10">
          <div className="flex items-center justify-between mb-4">
            <span className="text-white/60">Suscripción Mensual</span>
            <span className="text-3xl font-bold text-[#C5A14C]">$3<span className="text-lg text-white/60">/mes</span></span>
          </div>
          
          <ul className="text-left space-y-2 text-sm text-white/70">
            <li>✓ Acceso completo a todas las funciones</li>
            <li>✓ Sincronización en la nube</li>
            <li>✓ Soporte técnico prioritario</li>
            <li>✓ Actualizaciones automáticas</li>
          </ul>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/checkout/app-mobile')}
            className="w-full bg-[#C5A14C] text-[#02040A] font-bold rounded-full px-8 py-4 hover:bg-[#B08F3C] hover:shadow-[0_0_20px_rgba(197,161,76,0.4)] transition-all duration-300 flex items-center justify-center gap-2"
          >
            <CreditCard className="w-5 h-5" />
            Suscribirse Ahora
          </button>

          {/* Política de Devolución */}
          <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-3">
            <p className="text-xs font-semibold text-amber-400 mb-1">
              📋 Política de Devolución
            </p>
            <p className="text-xs text-amber-300/80">
              Todas las ventas son finales. No se realizan devoluciones ni reembolsos.
            </p>
          </div>

          <button
            onClick={handleLogout}
            className="w-full bg-white/10 text-white font-bold rounded-full px-4 py-3 hover:bg-white/20 transition-all duration-300 text-sm"
          >
            Cerrar Sesión
          </button>

          <p className="text-xs text-white/40">
            ¿Tienes problemas? Contacta al administrador
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export function TrialBanner({ daysLeft }) {
  const navigate = useNavigate();

  if (daysLeft < 0 || daysLeft > 7) return null;

  const isUrgent = daysLeft <= 2;

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`${
        isUrgent ? 'bg-red-500/10 border-red-500/20' : 'bg-amber-500/10 border-amber-500/20'
      } border-b px-6 py-3 flex items-center justify-between`}
    >
      <div className="flex items-center gap-3">
        <AlertTriangle className={`w-5 h-5 ${isUrgent ? 'text-red-500' : 'text-amber-500'}`} />
        <p className={`text-sm font-semibold ${isUrgent ? 'text-red-400' : 'text-amber-400'}`}>
          {daysLeft === 0 && '¡Tu prueba expira hoy!'}
          {daysLeft === 1 && '¡Tu prueba expira mañana!'}
          {daysLeft > 1 && `Te quedan ${daysLeft} días de prueba`}
        </p>
      </div>

      <button
        onClick={() => navigate('/checkout/app-mobile')}
        className={`${
          isUrgent ? 'bg-red-500' : 'bg-amber-500'
        } text-white text-sm font-bold px-4 py-2 rounded-full hover:opacity-90 transition-opacity`}
      >
        Suscribirse
      </button>
    </motion.div>
  );
}
